import Repo from '../../repo';
import shell from './shell';
import i18n from '../../localization';

const state = {
    paymentConfiguration: {
        token: "",
        mode: null,
        languageMode: 'en',
        amount: 0,
        quantity: null,
        currencySymbol: '$',
        accountName: '',
        accountNumber: '',
        onSuccessForwardUrl: '',
        onCancelForwardUrl: '',
        countryCode: 'US', //get it from the url
        billingAddress: {
            addressLine1: null,
            addressLine2: null,
            city: null,
            stateCd: null,
            zip: null,
        },
        locationId: '',
        additionalParameters: ''
    },
    quickPayCustomer: {
        customerNumber: 0,
        aNumber: "",
        billingType: "",
        customerType: "",
        statusCode: "",
        confirmed: false
    },
    reversiblePayments: [
    ]
};

const getters = {
    paymentConfiguration: state => state.paymentConfiguration,
    quickPayCustomer: state => state.quickPayCustomer,
    reversiblePayments: state => state.reversiblePayments
}
const mutations = {

    SET_PAYMENTCONFIGURATION(state, paymentData) {
        Object.assign(state.paymentConfiguration, paymentData)
    },
    SET_REVERSIBLEPAYMENTS(state, payload) {
        state.reversiblePayments = payload.payments;
    },
    SET_CUSTOMERNUMBER(state, customerNumber) {
        state.quickPayCustomer.customerNumber = customerNumber;
    },
    SET_QUICKPAY_CUSTOMER(state, customer) {
        Object.assign(state.quickPayCustomer, customer);
    }
}
const actions = {
    setPaymentConfiguration({ commit, state }, paymentData) {
        commit("SET_PAYMENTCONFIGURATION", paymentData);
    },
    getPaymentToken({ commit, state }, tokenRequest) {
        Repo.PaymentConfigurationService.GetPaymentToken(tokenRequest).then(res => {
            if (!res.paymentToken) {
                shell.mutations.ADD_ERROR_MESSAGES(shell.state, "Something went wrong with creating your payment token. Please close and try again");
            }
            else {
                if (tokenRequest.PaymentCampaignCode == "PAYMENTPLAN") {
                    // Call Bluenet post message to register Chase HPF event listeners
                    // The reason is because the Chase HPF event listener code needs to reside at the top most parent window
                    // to receive Chase HPF post messages which is the Bluenet app in this case.
                    // Note: See the following code (Line 266) for more details on how this is wired up.
                    //       https://dev.azure.com/ambitenergy/Operations/_git/CIS.BN3?path=%2FCIS.Bn3Web%2Fwwwroot%2Fassets%2Fjs%2FhpfMessageRouter.js&_a=contents&version=GBmaster
                    window.top.postMessage({ 'subject': 'call-hppIFramePaymentPlan-function' }, '*');
                }

                Repo.PaymentConfigurationService.RedirectToHostedPaymentPage(res.paymentToken);
            }
        });
    },
    getPaymentMethodToken({ commit, state }, tokenRequest) {
        Repo.PaymentConfigurationService.GetPaymentToken(tokenRequest).then(res => {
            if (!res.paymentToken) {
                shell.mutations.ADD_ERROR_MESSAGES(shell.state, "Something went wrong with creating your payment token. Please close and try again");
            } else {
                Repo.PaymentConfigurationService.RedirectToPaymentMethodPage(res.paymentToken);
            }
        });
    },
    isDonorValid({ commit, state }, request) {
        Repo.DonationService.IsDonorValid(request).then(res => res);
    },
    setQuickPayCustomer({ commit, state }, customer) {
        commit("SET_QUICKPAY_CUSTOMER", customer);
    },
    validateQuickPayCustomer({ commit, state }, request) {
        return Repo.QuickPayService.ValidateAccountNumber(request).then(res => {
            if (res.isValid) {
                commit("SET_PAYMENTCONFIGURATION", { accountName: res.firstName + " " + res.lastName });
                commit("SET_QUICKPAY_CUSTOMER", { customerNumber: res.customerNumber, aNumber: request.AccountNumber });
                return true;
            } else {
                shell.mutations.ADD_ERROR_MESSAGES(shell.state, "The provided customer information is not valid.")
                return false;
            }
        })
    },
    getCustomerName({ commit, state }, request) {
        return Repo.QuickPayService.GetCustomerName(request).then(res => {
            if (res.isValid) {
                commit("SET_PAYMENTCONFIGURATION", { accountName: res.firstName + " " + res.lastName });
                return true;
            } else {
                shell.mutations.ADD_ERROR_MESSAGES(shell.state, "The provided customer information is not valid.");
                return false;
            }
        })
    },
    setReversiblePaymentsFor({ commit, state }, request) {
        return Repo.HostedPaymentService.GetReversiblePaymentsFor(request).then(res => {
            if (res && !res.error) {
                commit("SET_REVERSIBLEPAYMENTS", { payments: res });
                return true;
            } else {
                shell.mutations.ADD_ERROR_MESSAGES(shell.state, i18n.t('REVERSIBLE_ERROR_GET'));
                return false;
            }
        })
    }
}




export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}